import React, { useState, useEffect, useRef } from 'react';
import { useParams } from "react-router-dom";
import NewsCard from './NewsCard';
import styles from "./NewsPage.module.scss";
import NewsModal from '../../components/modals/NewsModal';
import { getNews, getNewsCategories, getNewsDetail } from "../../services/axiosService.js";
import { useNavigate } from 'react-router-dom';
import ArrowDown from '../../components/icons/ArrowDown';

const NewsPage = () => {
  var navigate = useNavigate();
  const { newsId } = useParams();
  const limit = 9;
  const isFirstRender = useRef(true);
  const hasFetchedInitial = useRef(false);
  const [newsItems, setNewsItems] = useState([]);
  const [newsItemData, setNewsItemData] = useState(null);
  const [isNewsModalOpen, setIsNewsModalOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [offset, setOffset] = useState(0);
  const [category, setCategory] = useState(null);
  const [hasMoreNews, setHasMoreNews] = useState(true);
  const [isFetching, setIsFetching] = useState(false);

  const handleOpenModal = async (itemId) => {
    if(!itemId) return;
    try {
      const fetchedNewsDetail = await getNewsDetail(itemId);
      if(fetchedNewsDetail?.data){
        setNewsItemData(fetchedNewsDetail.data);
        setIsNewsModalOpen(true);
      }else{
        handleCloseModal();
      }
    } catch (error) {
      handleCloseModal();
    }
  };

  const handleCloseModal = () => {
    setIsNewsModalOpen(false);
    setNewsItemData(null);
    navigate('/news');
  }

  const fetchCategories = async () => {
    try {
      const fetchedCategories = await getNewsCategories();
      setCategories(Array.isArray(fetchedCategories?.data) ? fetchedCategories.data : []);
    } catch (error) {
      setCategories([]);
    }
  };

  const fetchNews = async (offset = 0) => {
    setIsFetching(true);
    try {
      const fetchedNews = await getNews(category, limit, offset);
      const newNews = Array.isArray(fetchedNews?.data?.news) ? fetchedNews.data.news : [];
  
      if (offset === 0) {
        setNewsItems(newNews);
      } else {
        setNewsItems(prev => [...prev, ...newNews]);
      }
      
      const total = fetchedNews?.data?.total;

      if (typeof total !== 'number' || total <= offset + limit) {
        setHasMoreNews(false);
      }

    } catch (error) {
      console.error("Error fetching news:", error);
    } finally {
      setIsFetching(false);
    }
  };

  const showMore = async () => {
    const newOffset = offset + limit;
    setOffset(newOffset);
    fetchNews(newOffset);
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setOffset(0);
    setHasMoreNews(true);
    fetchNews(0);
  }, [category]);

  useEffect(
    () => {
      handleOpenModal(newsId);
    }, [newsId]
  );
 
  useEffect(() => {
    if (!hasFetchedInitial.current) {
      fetchCategories();
      fetchNews(0);
      hasFetchedInitial.current = true;
    }
  }, []);

  return (
    <>
      <div className={styles.newsContainer}>
        <h1 className={styles.newsTitle}>NOVEDADES</h1>
        <p className={styles.newsSubtitle}>Conoce las últimas noticias y lanzamientos de Fancy Monas.</p>
        <div className={styles.newsCategories}>
          <span
            className={`${styles.categories} ${category === null ? styles.active : ''}`}
            onClick={() => setCategory(null)}
          >Todos</span>
          {categories.map((categoryItem, index) => (
            <span
              key={index}
              className={`${styles.categories} ${category === categoryItem.id ? styles.active : ''}`}
              onClick={() => setCategory(categoryItem.id)}
            >{categoryItem.name}</span>
          ))}
        </div>
        <div className={styles.newsGrid}>
          {newsItems.map((item, index) => (
            <NewsCard key={item.id} newsItem={item} onOpen={() => handleOpenModal(item.id)} />
          ))}
        </div>
        {!isFetching && newsItems.length === 0 && category !== null && (
          <p style={{ textAlign: 'center', fontSize: '1rem', marginTop: '2rem' }}>
            No se han encontrado resultados para esa categoría.
          </p>
        )}
        {!isFetching && hasMoreNews && (
          <div className={styles.showMoreContainer}>
            <button
              className={styles.showMoreButton}
              onClick={showMore}
              disabled={isFetching}
            >
              <span className={styles.arrowIco}>
                <ArrowDown width={15} height={14} color={"#FFF"} />
              </span>
              <span>
                Ver más
              </span>
            </button>
          </div>
        )}
      </div>
      <NewsModal
        isOpen={isNewsModalOpen}
        handleCloseModal={handleCloseModal}
        newsItem={newsItemData}
      />
    </>
  );
};

export default NewsPage;
